import { render, staticRenderFns } from "./woncology.vue?vue&type=template&id=c48fee26"
import script from "./woncology.vue?vue&type=script&lang=js"
export * from "./woncology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports